export const SDK_NAME = 'sentry.javascript.browser';
export const SDK_VERSION = '5.5.0';
